import { apiConfig } from "../config/apiConfig";
import { apiCaching } from "../config/cachingConfig";
import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { conceptIdForAllBrands } from "../nbly-brand/helper_functions";
import { attachEventListenerForHeroBannerClaim } from "../util/coupons-event-handling";

export class HeroComponent {
    private data: any;
    private pageNumber: number;
    private pageSize: number;
    constructor(result: any) {
        this.pageNumber = 1; // Initial page number
        this.pageSize = 10; // Number of items per page
        if (document.querySelector(".hero-review"))
            this.getData(result);
    }

    static async create() {
        const reviewDom  = document.querySelector('.hero-review') as HTMLElement;
        if(!reviewDom) 
            return;
        const conceptId = conceptIdForAllBrands();
        if(!conceptId) 
            return;
        let countryId, result;
        try {
            if (sessionStorage.getItem('countryCode') != null) {
                countryId = sessionStorage.getItem('countryCode')?.toLowerCase() == "us" ? "1" : "2";
            } else {
                countryId = (document.getElementById("countryCode") as HTMLInputElement)?.value.toLowerCase() == "us" ? "1" : "2";
            }
            let localwebId: any = document.getElementById('local_weblocationId');
            const weblocationID: any = document.getElementById('weblocationId');
            if(localwebId === null && weblocationID !== null) {
                localwebId = weblocationID;
            }
            const getWbLocationId: any = localwebId?.value || localStorage.getItem('franchiseWebLocationId');
            const url = apiConfig.TESTIMONIAL_REVIEWS + `/${conceptId}/${getWbLocationId ?? 0}/${countryId}/1/1/1`;
            result = await cachedAPIWrapper(url, apiCaching.TestimonyAndReview);
            if(result.length && result[0]?.overallRating && result[0]?.grandTotal){
                const obj = {
                    "or" : result[0]?.overallRating,
                    "gt" : result[0]?.grandTotal
                }
                sessionStorage.setItem(`rev-${getWbLocationId || 'national'}`, JSON.stringify(obj));
            }
        } catch(err) {
            console.error("Review API has failed", err)
        }

        return new HeroComponent(result);
    }

    private popularServiceBanner() {
        const heroBanner = document.querySelector('.hero-banner.form-on') as HTMLElement;
        const popularServicesBanner = document.querySelector('.popular-services-banner') as HTMLElement;
        if (heroBanner && popularServicesBanner?.previousElementSibling) {
            popularServicesBanner.classList.add('banner-under-form');
        }
    }

    public generateRatingStars(rating: number): string {
        const fullStar = '<span class="star full">★</span>';
        const emptyStar = '<span class="star empty">☆</span>';
        const numberOfFullStars = Math.round(rating);
        const hasHalfStar = rating % 1 !== 0;
        const numberOfEmptyStars = hasHalfStar ? 5 - numberOfFullStars - 1 : 5 - numberOfFullStars;
        return fullStar.repeat(numberOfFullStars) + (hasHalfStar ? '<span class="star half">★</span>' : '') + emptyStar.repeat(numberOfEmptyStars);
    }

    private hideReviewSection(){
        //setting visibilty hidden so that the default space is not removed and so that the banner size remains contant irrespective of reviews.
        const reviewSection = document.querySelector('.hero-review') as HTMLElement;
        try{
            reviewSection.style.visibility = "hidden";
            //for Logging
            const localwebId: any = document.getElementById('local_weblocationId');
            const getWbLocationId: any = localwebId?.value || localStorage.getItem('franchiseWebLocationId');
            if(getWbLocationId === null)
                console.warn("No reviews present for National Site")
            else
                console.warn(`No reviews present for ${getWbLocationId} or Invalid Location`);
            }
        catch{
            console.warn("'hero-review' class is missing in the DOM");
        }
    }

    private showReviewSection(){
       
        const reviewSection = document.querySelector('.hero-review') as HTMLElement;
        if(reviewSection) {
            reviewSection.style.visibility = "visible";
            this.createReviewClickableWrapper();
        }
    }

    private createReviewClickableWrapper() {
        const heroReviewElement = document.querySelector('.hero-review') as HTMLElement;
        
        if (heroReviewElement) {
            const customerWrap = heroReviewElement.querySelector('.customer-wrap') as HTMLElement;
            const ratingWrap = heroReviewElement.querySelector('.rating-wrap') as HTMLElement;
            
            if (customerWrap && ratingWrap) {
                // Check if customer-data has an anchor tag with non-empty href
                const customerData = customerWrap.querySelector('.customer-data') as HTMLElement;
                const anchorTag = customerData?.querySelector('a') as HTMLAnchorElement;
                const href = anchorTag?.getAttribute('href');
                
                if (anchorTag && href && href.trim() !== '') {
                    // Create wrapper anchor element
                    const wrapperAnchor = document.createElement('a');
                    wrapperAnchor.href = href;
                    
                    // Copy target attribute if exists
                    const target = anchorTag.getAttribute('target');
                    if (target) {
                        wrapperAnchor.setAttribute('target', target);
                    }
                    
                    // Move both child elements into the wrapper
                    customerWrap.parentNode?.insertBefore(wrapperAnchor, customerWrap);
                    wrapperAnchor.appendChild(customerWrap);
                    wrapperAnchor.appendChild(ratingWrap);
                }
            }
        }
    }
    
    private getData(result: any) {
        const reviewTotal = document.querySelector('.customer-data .hero-review-heading');
        const rating = document.querySelector('.rating-wrap .hero-review-heading');
        const ratingStar = document.querySelector('.rating-wrap .hero-rating .rating');
            
        // If DOM is missing, hide section immediately
        if (!reviewTotal || !rating || !ratingStar) {
            this.hideReviewSection();
            return;
        }
         // Parse hero banner config
    const { minimumReviewCount, minimumCustomerRating } = this.getHeroConfig();

        if(result){
            if(result?.length===0 || result[0]?.overallRating === 0 || result[0]?.grandTotal === 0){
                this.hideReviewSection();
            } else if (reviewTotal && rating && ratingStar) {
                // Check conditions only if minimumReviewCount and minimumCustomerRating exist
                const checkReviewCount = this.checkReviewCount(result, minimumReviewCount);
                const checkCustomerRating = this.checkCustomerRating(result, minimumCustomerRating);

                if (checkReviewCount && checkCustomerRating) {
                    this.updateReview(result[0], reviewTotal, rating, ratingStar);
                    this.showReviewSection();
                } else {
                    this.hideReviewSection();
                }
            } else {
                this.hideReviewSection();
            }
        }   
    }
    private updateReview(data: any, reviewTotal: any, rating: any, ratingStar: any) {
        reviewTotal.textContent = Number(data.grandTotal).toLocaleString();
        rating.textContent = `${data?.overallRating == 0 ? data?.reviewStarRating : data?.overallRating}/5`;
        ratingStar.innerHTML = this.generateRatingStars(data?.overallRating ? Math.round(data?.overallRating) : 0);
    }
    private getHeroConfig() {
        //586517 - Default value for minimum number of total customer reviews should be set to 15. Default value for minimum overall customer rating should be set to 4.5
        let minimumReviewCount = 15;
        let minimumCustomerRating = 4.5;

        const heroBannerElement = document.getElementById('hero-banner') as HTMLInputElement;
        if (heroBannerElement?.value) {
            try {
                const config = JSON.parse(heroBannerElement.value);
                minimumReviewCount = Number(config?.customerreview?.minimumReviewCount) || minimumReviewCount;
                minimumCustomerRating = Number(config?.customerreview?.minimumCustomerRating) || minimumCustomerRating;
            } catch {
                console.warn("Error parsing hero-banner configuration");
            }
        }
        return { minimumReviewCount, minimumCustomerRating };
    }
    private checkReviewCount(result: any, minimumReviewCount: number) {
        return minimumReviewCount > 0
            ? result[0]?.grandTotal > minimumReviewCount
            : true;
    }
    private checkCustomerRating(result: any, minimumCustomerRating: number) {
        return minimumCustomerRating > 0
            ? result[0]?.overallRating > minimumCustomerRating
            : true;
    }
}

(async () => {
    // Prevent duplicate initialization
    if ((globalThis as any).__HeroComponentInitialized) return;
    (globalThis as any).__HeroComponentInitialized = true;
    await HeroComponent.create();
    attachEventListenerForHeroBannerClaim();
})();
